<template>
  <div class="product-list-product" :class="classes">
    <div class="image" :style="productImage"></div>

    <div class="text">
      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"
      />

      <div class="product-list-product-info">
        <h2
          class="product-title"
          @click="highlightField('product title')">
          {{parse(product).product_title}}
        </h2>

        <h3>
          <span @click="highlightField('product price')">
            {{parse(product).product_currency}}{{parse(product).product_price}}
          </span>

          <span v-if="hasComparePrice" class="compare-price" @click="highlightField('product compare price')">
            {{parse(product).product_currency}}{{parse(product).product_compare_price}}
          </span>
        </h3>

        <div v-html="parse(product).product_description" @click="highlightField('product description')"></div>

        <div class="product-controls">
          <ProductQuantity @updateQuantity="updateQuantity"/>
          <button class="btn atc-btn is-dark" @click="addToCart">Add to Cart</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'
import notification from '@/mixins/notification'

import ProductQuantity from './ProductQuantity'

export default {
  name: 'product-list-product',

  data() {
    return {
      qty: 1
    }
  },

  props: {
    product: Object,
    demoMode: Boolean
  },

  components: {
    ProductQuantity
  },

  mixins: [parseComponent, notification],

  computed: {
    productImage() {
      let image = this.demoMode ? this.parse(this.product).image_url : this.product.image_versions[0].url
      return `background-image:url('${image}')`
    },

    hasComparePrice() {
      return !!this.parse(this.product).product_compare_price
    },

    classes() {
      return [
        'product-list-product',
        this.parse(this.product).text_position,
        this.parse(this.product).text_width,
        this.parse(this.product).text_alignment,
        {'is-boxed': this.parse(this.product).boxed},
        {'is-fixed': this.parse(this.product).fixed_image_height},
        {'has-spacing': this.parse(this.product).bottom_spacing}
      ]
    }
  },

  methods: {
    addToCart() {
      this.$emit(
        'addToCart',
        this.parse(this.product).product_title,
        this.parse(this.product).product_currency,
        this.parse(this.product).product_price,
        this.parse(this.product).product_category,
        this.qty,
        this.images[0] || ''
      )

      this.triggerNotification('success', 'product', 'added')
    },

    updateQuantity(quantity) {
      this.qty = quantity
    }
  }
}
</script>

<style lang="sass">
@import '../../../stylesheets/base/variables'
@import '../../../stylesheets/helpers/mixins'
@import '../../../stylesheets/helpers/extends'
@import '../../../stylesheets/base/theme'

.product-list-product
  transition: all .3s ease-in-out

  @include media($media-gt-small)
    display: flex
    min-height: 200px

  &.is-fixed
    .image, .responsive-image
      max-height: 300px

  .compare-price
    color: $color-error
    text-decoration: line-through

  .responsive-image
    height: 100%
    display: flex

    img
      object-fit: cover
      object-position: 50% 50%
      width: 100%

  .product-list-product-info
    width: 100%

  .text
    padding: $gap-medium
    display: flex
    position: relative
    transition: all .3s ease-in-out

    h3
      font-weight: bold
      font-size: 18px
      margin-top: 0

  .product-controls
    @include media($media-gt-medium)
      .product-quantity
        text-align: left

    .atc-btn
      display: block
      margin: $gap-medium auto

      @include media($media-gt-medium)
        margin: $gap-small 0 0

  &.is-boxed
    box-shadow: $content-shadow
    background: #fff

  &.has-spacing
    margin-bottom: $gap-medium

  @include media($media-gt-small)
    &.text-left
      flex-direction: row-reverse

    &.text-right
      flex-direction: row

    &.text-left, &.text-right
      &.one-third
        .text
          flex-basis: percentage(1/3)

      &.half
        .text
          flex-basis: percentage(1/2)

      &.two-thirds
        .text
          flex-basis: percentage(2/3)

      &.three-quarters
        .text
          flex-basis: percentage(3/4)

      &.align-top
        .text
          align-items: top

      &.align-middle
        .text
          align-items: center

      &.align-bottom
        .text
          align-items: flex-end

  .image
    width: 100%
    min-height: 200px
    background-size: cover
    background-position: 50% 50%
    flex: 1
</style>
